module.exports = __webpack_public_path__ + "media/fyt_m3.472df8fa.mp4";